import { useLazyQuery } from '@apollo/client';
import { useMelwaysInfo } from '@seek/melways-react';
import {
  DEFAULT_SUGGESTION_COUNT,
  getMelwaysZoneByMarket,
  LocationFilter,
} from '@ts-internal/shared-lib';

import { GetSuggestionsForLocationDocument } from 'src/generated/graphql';

type Props = Omit<
  Parameters<typeof LocationFilter>[0],
  'suggestions' | 'onDebouncedSearchTextChange' | 'onSearchTextChange'
>;

export const CandidateLocationFilter = (props: Props) => {
  const { language } = useMelwaysInfo();
  const zone = getMelwaysZoneByMarket(props.marketState.value);

  const [triggerGetSuggestions, { data }] = useLazyQuery(
    GetSuggestionsForLocationDocument,
    {
      // Solution: not cache this query at all.
      fetchPolicy: 'no-cache',
    },
  );

  const suggestions = (data?.mkLocationSuggestions || []).map(
    ({ id, text }) => ({
      id: id.toString(),
      name: text,
    }),
  );

  const handleSearchTextChange = (newSearchText: string) => {
    if (newSearchText) {
      const kind = [
        'Country',
        'Region',
        'State',
        'SEEKLocation',
        'SEEKArea',
        'Suburb',
      ];

      triggerGetSuggestions({
        variables: {
          searchText: newSearchText,
          session: '',
          kind,
          zone,
          count: DEFAULT_SUGGESTION_COUNT,
          languageCode: language,
          countries: [props.marketState.value],
        },
      });
    }
  };

  return (
    <LocationFilter
      {...props}
      suggestions={suggestions}
      onDebouncedSearchTextChange={handleSearchTextChange}
    />
  );
};
